/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import './plugins/apexcharts-shim.js'
import VueApexCharts from './plugins/vue-apexcharts.js'

Vue.component('vue-apexcharts', VueApexCharts)
Vue.component('VueApexCharts', VueApexCharts)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import 'devextreme/dist/css/dx.light.css';

// axios
// import axios from "./axios.js"
// Vue.prototype.$http = axios

// API Calls
// import "./http/requests"

// mock
// import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
// import VueClipboard from 'vue-clipboard2'
// Vue.use(VueClipboard);

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBLqXGqMshIRPv3x9jR0elDpow5AnC-cOs',
    libraries: 'places,drawing,geometry', // necessary for directions
  },
});

import { createEcho } from '@/plugins/echo'

export var echo_instance = createEcho({
  host: process.env.VUE_APP_WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  },
});
Vue.prototype.$echo = echo_instance



// // Vuejs - Vue wrapper for hammerjs
// import { VueHammer } from 'vue2-hammer'
// Vue.use(VueHammer)



// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// Sentry.init({
//   dsn: 'https://be64cdb568664777ba458314e03587f1@o412006.ingest.sentry.io/5351845',
//   integrations: [new VueIntegration({ Vue, attachProps: true })],
// });

// to fix checkAll component of vs-table
// const BaseVsCheckbox = Vue.options.components.VsCheckbox
// const VsCheckbox = BaseVsCheckbox.extend({
//   computed: {
//     listeners() {
//       return {
//         ...this.$listeners
//       }
//     }
//   }
// })

// Vue.component('VsCheckbox', VsCheckbox)

// Vue.component('GmapMap', VueGoogleMaps.Map);
// Vue.component('GmapMarker', VueGoogleMaps.Marker);
// Vue.component('GmapPolyline', VueGoogleMaps.Polyline);

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
